<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Copyright</h1>
</div>
</div>
<p class="first" style="text-align: center;">
	Diversion Books<br/>
	A Division of Diversion Publishing Corp.<br/>
	443 Park Avenue South, Suite 1004<br/>
	New York, NY 10016<br/>
<a href="http://www.DiversionBooks.com" target="_blank">www.DiversionBooks.com</a></p>
<p class="sectiontop" style="text-align: center;">
	Copyright © 1992 by Edna Buchanan<br/>
	All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</p>
<p class="sectiontop" style="text-align: center;">
	For more information, email <a href="mailto:info@diversionbooks.com">info@diversionbooks.com</a></p>
<p class="sectiontop" style="text-align: center;">
	First Diversion Books edition April 2014<br/>
	ISBN: <span style="font-size: 1em; line-height: 1.375; font-family: 'Liberation Serif', serif; text-align: justify;">978-1-626812-49-9</span></p>
<div style="page-break-after: always;">
<div style="display: none;">
</div>
</div>
<h1>
	More from Edna Buchanan</h1>
<p class="sectiontop" style="text-align: center;">
<em><strong>Fiction</strong></em><br/>
<span href="#/0425138240_38_abt" title="Link target outside of Sample"><span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">Nobody Lives Forever</span><br/>
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">Miami, It’s Murder</span><br/>
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">Suitable For Framing</span><br/>
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">Contents Under Pressure</span><br/>
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">Act Of Betrayal</span><br/>
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">Margin of Error</span></span></p>
<p class="sectiontop" style="text-align: center;">
<em><strong>Non-Fiction</strong></em><br/>
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">Carr: Five Years of Rape and Murder</span></p>
<div style="page-break-after: always;">
<div style="display: none;">
</div>
</div>
<p class="sectiontop" style="text-align: center;">
<em>For Quinn and Callie Cagney, and every little girl with big dreams.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 0425138240_06_cpy.vue?ed2be1e8